var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40C351",
    d: "M16.506 8.261A8.251 8.251 0 0 0 .118 7.436a8.37 8.37 0 0 0 .982 5.438l-.734 2.731a.83.83 0 0 0 .099.644.76.76 0 0 0 .28.28.82.82 0 0 0 .636.083l2.698-.742A8.25 8.25 0 0 0 8.254 17a8.376 8.376 0 0 0 8.252-8.739"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.764 4.994c-.776.71-.916 1.724-.108 3.3a10.36 10.36 0 0 0 3.722 3.862c1.345.768 2.261.966 3.202.421a1.386 1.386 0 0 0 .8-1.518 2 2 0 0 0-.23-.264l-1.651-1.14a.58.58 0 0 0-.553 0q-.322.255-.61.546a.26.26 0 0 1-.281.057A8.1 8.1 0 0 1 6.76 7.972a.215.215 0 0 1 .05-.264c.131-.14.544-.627.544-.627a.55.55 0 0 0 .074-.264 1.3 1.3 0 0 0-.058-.256l-1.114-1.65a.71.71 0 0 0-.635-.289c-.323.009-.63.142-.858.372"
  })));
};
export default SvgWhatsapp;